import React from "react";
import "./App.css";
import Hero from "./components/Hero";
import Invitation from "./components/Invitation";
import Gallery from "./components/Gallery";
import WhenWhere from "./components/WhenWhere";
import Schedule from "./components/Schedule";
import Directions from "./components/Directions";
import Gifts from "./components/Gifts";

function App() {
  return (
    <div className="page">
      <header className="nav" aria-label="Sections">
        <a href="#top">Top</a>
        <a href="#gallery">Gallery</a>
        <a href="#invitation">Invitation</a>
        <a href="#when-where">When & where</a>
        <a href="#schedule">Schedule</a>
        <a href="#directions">Directions</a>
        <a href="#gifts">Gifts</a>
      </header>
      <main className="main">
        <Hero />
        <Gallery />
        <Invitation />
        <WhenWhere />
        <Schedule />
        <Directions />
        <Gifts />
      </main>
      <footer className="footer">
        <p>Sarah & Paul · May 6, 2026 · New York City</p>
      </footer>
    </div>
  );
}

export default App;
